import React from 'react'

const ContactUs = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Contact Us </h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
      style={{ textAlign: "justify" }}
    >
      <h6>A STATE GOVERNMENT UNDERTAKING</h6>
      <p><strong>Address :</strong> BEEJ BHAWAN, BAYS 3-6 
      SECTOR-2, PANCHKULA</p>
      <p><strong>Phone :</strong> 0172-2577755</p>
      <p><strong>Email :</strong> mdhsdcl@gmail.com</p>
    </div>
    </div>
  )
}

export default ContactUs
